import React from "react";

const TabContactos = ({
  searchTermContacto,
  setSearchTermContacto,
  handleDownloadContactosCSV,
  filteredContactosData,
  contactosData,
  handleSortContactos,
  contactosSortField,
  contactosSortDirection,
  setSelectedContacto,
  setIsViewContactModalOpen,
  handleDownloadContactoIndividual,
  isViewContactModalOpen,
  selectedContacto,
  handleCloseViewContactModal,
}) => {
  return (
    <>
      {/* Barra de búsqueda y botón de descarga */}
      <div className="mb-5">
        <div className="flex flex-col md:flex-row gap-4 mb-4">
          <div className="w-full md:w-2/3">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
                <i className="bx bx-search text-gray-400 text-xl"></i>
              </div>
              <input
                type="text"
                className="w-full pl-12 pr-4 py-3.5 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200 text-sm"
                placeholder="Buscar por nombre, email, empresa, teléfono o mensaje"
                value={searchTermContacto}
                onChange={(e) => setSearchTermContacto(e.target.value)}
              />
            </div>
          </div>
          <div className="w-full md:w-1/3">
            <button
              onClick={handleDownloadContactosCSV}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-4 rounded-lg flex items-center justify-center transition-colors shadow-sm"
              title="Descargar todos los contactos en CSV"
            >
              <i className="bx bx-download text-xl mr-2"></i>
              Descargar Contactos (CSV)
            </button>
          </div>
        </div>
        <div className="text-sm text-gray-600 flex items-center justify-between">
          <span>
            <i className="bx bx-info-circle text-blue-600 mr-1"></i>
            Total de contactos: <strong>{filteredContactosData.length}</strong>
            {searchTermContacto && ` de ${contactosData.length}`}
          </span>
          {searchTermContacto && (
            <button
              onClick={() => setSearchTermContacto("")}
              className="text-blue-600 hover:text-blue-800 flex items-center"
            >
              <i className="bx bx-x text-lg"></i>
              Limpiar búsqueda
            </button>
          )}
        </div>
      </div>

      <div className="flex justify-center w-full">
        <div className="w-full overflow-hidden rounded-lg shadow">
          {/* Contenedor con scroll horizontal y vertical */}
          <div className="overflow-x-auto overflow-y-auto max-h-[600px]">
            <table className="w-full text-sm text-left text-gray-700 min-w-[950px]">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 border-b sticky top-0 z-10">
                <tr>
                  <th
                    className="px-4 py-3 font-semibold cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSortContactos("id")}
                  >
                    <div className="flex items-center justify-between">
                      <span>ID</span>
                      <span className="ml-2 text-gray-500">
                        {contactosSortField === "id" ? (
                          contactosSortDirection === "asc" ? (
                            <i className="bx bxs-up-arrow text-blue-600"></i>
                          ) : (
                            <i className="bx bxs-down-arrow text-blue-600"></i>
                          )
                        ) : (
                          <i className="bx bx-sort-alt-2 text-gray-400"></i>
                        )}
                      </span>
                    </div>
                  </th>
                  <th
                    className="px-4 py-3 font-semibold cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSortContactos("nombre")}
                  >
                    <div className="flex items-center justify-between">
                      <span>Nombre</span>
                      <span className="ml-2 text-gray-500">
                        {contactosSortField === "nombre" ? (
                          contactosSortDirection === "asc" ? (
                            <i className="bx bxs-up-arrow text-blue-600"></i>
                          ) : (
                            <i className="bx bxs-down-arrow text-blue-600"></i>
                          )
                        ) : (
                          <i className="bx bx-sort-alt-2 text-gray-400"></i>
                        )}
                      </span>
                    </div>
                  </th>
                  <th className="px-4 py-3 font-semibold">Teléfono</th>
                  <th
                    className="px-4 py-3 font-semibold cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSortContactos("email")}
                  >
                    <div className="flex items-center justify-between">
                      <span>Email</span>
                      <span className="ml-2 text-gray-500">
                        {contactosSortField === "email" ? (
                          contactosSortDirection === "asc" ? (
                            <i className="bx bxs-up-arrow text-blue-600"></i>
                          ) : (
                            <i className="bx bxs-down-arrow text-blue-600"></i>
                          )
                        ) : (
                          <i className="bx bx-sort-alt-2 text-gray-400"></i>
                        )}
                      </span>
                    </div>
                  </th>
                  <th
                    className="px-4 py-3 font-semibold cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSortContactos("empresa")}
                  >
                    <div className="flex items-center justify-between">
                      <span>Empresa / Puesto</span>
                      <span className="ml-2 text-gray-500">
                        {contactosSortField === "empresa" ? (
                          contactosSortDirection === "asc" ? (
                            <i className="bx bxs-up-arrow text-blue-600"></i>
                          ) : (
                            <i className="bx bxs-down-arrow text-blue-600"></i>
                          )
                        ) : (
                          <i className="bx bx-sort-alt-2 text-gray-400"></i>
                        )}
                      </span>
                    </div>
                  </th>
                  <th
                    className="px-4 py-3 font-semibold cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSortContactos("numero_colaboradores")}
                  >
                    <div className="flex items-center justify-between">
                      <span>Colaboradores</span>
                      <span className="ml-2 text-gray-500">
                        {contactosSortField === "numero_colaboradores" ? (
                          contactosSortDirection === "asc" ? (
                            <i className="bx bxs-up-arrow text-blue-600"></i>
                          ) : (
                            <i className="bx bxs-down-arrow text-blue-600"></i>
                          )
                        ) : (
                          <i className="bx bx-sort-alt-2 text-gray-400"></i>
                        )}
                      </span>
                    </div>
                  </th>
                  <th className="px-4 py-3 font-semibold">Mensaje</th>
                  <th
                    className="px-4 py-3 font-semibold text-center w-32 cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSortContactos("fechaRegistro")}
                  >
                    <div className="flex items-center justify-center">
                      <span>Fecha</span>
                      <span className="ml-2 text-gray-500">
                        {contactosSortField === "fechaRegistro" ? (
                          contactosSortDirection === "asc" ? (
                            <i className="bx bxs-up-arrow text-blue-600"></i>
                          ) : (
                            <i className="bx bxs-down-arrow text-blue-600"></i>
                          )
                        ) : (
                          <i className="bx bx-sort-alt-2 text-gray-400"></i>
                        )}
                      </span>
                    </div>
                  </th>
                  <th className="px-4 py-3 font-semibold text-center w-32">
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredContactosData.length > 0 ? (
                  filteredContactosData.map((item) => (
                    <tr
                      key={item.id}
                      className={`border-b hover:bg-gray-50 transition-all duration-500 ${
                        item.resaltado
                          ? "bg-yellow-100 border-l-4 border-yellow-500"
                          : "bg-white"
                      }`}
                    >
                      <td className="px-4 py-4 font-medium">{item.id}</td>
                      <td className="px-4 py-4">{item.nombre}</td>
                      <td className="px-4 py-4">{item.numero}</td>
                      <td className="px-4 py-4">{item.email}</td>
                      <td className="px-4 py-4">{item.empresa}</td>
                      <td className="px-4 py-4 text-center">
                        {item.numero_colaboradores ?? "-"}
                      </td>
                      <td className="px-4 py-4 truncate max-w-[200px]">
                        {item.mensaje}
                      </td>
                      <td className="px-4 py-4 text-center text-blue-800 font-semibold">
                        {new Date(item.fechaRegistro).toLocaleDateString(
                          "es-MX",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          }
                        )}
                        <br />
                        <span className="text-xs text-gray-600">
                          {new Date(item.fechaRegistro).toLocaleTimeString(
                            "es-MX",
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                            }
                          )}
                        </span>
                      </td>
                      <td className="px-4 py-4">
                        <div className="flex justify-center items-center gap-2 min-h-[60px]">
                          <button
                            onClick={() => {
                              setSelectedContacto(item);
                              setIsViewContactModalOpen(true);
                            }}
                            className="bg-blue-600 hover:bg-blue-700 rounded-md text-white w-10 h-10 flex items-center justify-center transition-colors"
                            title="Ver detalles del contacto"
                          >
                            <i className="bx bx-show text-xl"></i>
                          </button>
                          <button
                            onClick={() =>
                              handleDownloadContactoIndividual(item)
                            }
                            className="bg-green-600 hover:bg-green-700 rounded-md text-white w-10 h-10 flex items-center justify-center transition-colors"
                            title="Descargar contacto en CSV"
                          >
                            <i className="bx bx-download text-xl"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="9"
                      className="px-6 py-8 text-center text-gray-500"
                    >
                      {searchTermContacto
                        ? "No se encontraron contactos que coincidan con tu búsqueda"
                        : "No hay registros de contacto"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal para ver contacto */}
      {isViewContactModalOpen && selectedContacto && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col">
            {/* Header */}
            <div className="bg-blue-600 px-6 py-4 flex items-center justify-center">
              <div className="flex items-center gap-2">
                <i className="bx bxs-user-detail text-2xl text-white"></i>
                <h2 className="text-white text-lg font-bold">
                  Detalles de Contacto
                </h2>
              </div>
            </div>

            {/* Body */}
            <div className="p-8 space-y-6 overflow-y-auto max-h-[75vh] text-gray-800">
              {/* Nombre y Teléfono */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <p className="text-sm text-gray-500 mb-1">Nombre</p>
                  <p className="font-semibold">{selectedContacto.nombre}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Teléfono</p>
                  <p className="font-semibold">{selectedContacto.numero}</p>
                </div>
              </div>

              {/* Email y Empresa */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <p className="text-sm text-gray-500 mb-1">Email</p>
                  <p className="font-semibold break-words">
                    {selectedContacto.email}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Empresa / Puesto</p>
                  <p className="font-semibold break-words">
                    {selectedContacto.empresa}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">
                    Núm. colaboradores
                  </p>
                  <p className="font-semibold">
                    {selectedContacto.numero_colaboradores ?? "No especificado"}
                  </p>
                </div>
              </div>

              {/* Mensaje */}
              <div>
                <p className="text-sm text-gray-500 mb-2">Mensaje</p>
                <div className="text-gray-700 whitespace-pre-line text-justify leading-relaxed">
                  {selectedContacto.mensaje}
                </div>
              </div>

              {/* Fecha de Registro */}
              <div className="text-center text-xs text-gray-400">
                Fecha de registro:{" "}
                {new Date(selectedContacto.fechaRegistro).toLocaleString(
                  "es-MX",
                  {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  }
                )}
              </div>
            </div>

            {/* Footer */}
            <div className="flex justify-center px-6 py-4 border-t">
              <button
                onClick={handleCloseViewContactModal}
                className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 px-8 rounded-md transition"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TabContactos;
